/**
 * @typedef {'VEHICLE_FINANCING'
 *           |'TRADE_IN'
 *           |'CAR_REPLACEMENT_SERVICE'
 *           |'PURCHASE_ADVICE'
 *           |'LEASING'
 *           |'MOPED_SALE'
 *           |'MOTORCYCLE_SALE'
 *           |'TEST_DRIVE'
 *           |'INSURANCES'} VEHICLE_PURCHASE_SERVICES
 */

/**
 * @const VEHICLE_PURCHASE_SERVICES_NAMES
 * @type {Record<VEHICLE_PURCHASE_SERVICES, VEHICLE_PURCHASE_SERVICES>}
 *
 * @description vehicle purchase services name items from dealer service api
 */
export const VEHICLE_PURCHASE_SERVICES_NAMES = {
  VEHICLE_FINANCING: 'VEHICLE_FINANCING',
  TRADE_IN: 'TRADE_IN',
  PURCHASE_ADVICE: 'PURCHASE_ADVICE',
  LEASING: 'LEASING',
  MOPED_SALE: 'MOPED_SALE',
  MOTORCYCLE_SALE: 'MOTORCYCLE_SALE',
  TEST_DRIVE: 'TEST_DRIVE',
  INSURANCES: 'INSURANCES',
};
